import {CustomLink} from "../../models";

export const links: CustomLink[] = [
    {
        title: 'Moodle',
        image: 'https://img.icons8.com/color/512/moodle.png',
        link: 'https://moodle.tutoring.sternad.dev/',
        color: '#fca605'
    },
    {
        title: 'GitHub',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Octicons-mark-github.svg/2048px-Octicons-mark-github.svg.png',
        link: 'https://github.com/sternadtutoring',
        color: 'white'
    },
    {
        title: 'Calendly',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgyn8Ng8PXWBZX5eLh8orPs-6Ntz65mAJHhg&s',
        link: 'https://calendly.com/tutoring-sternad/nachhilfeunterricht',
        color: '#0570fc'
    }
]